import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

const NoPages = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-16 mt-[75px] lg:mt-[95px]">
        <div className="max-w-2xl w-full text-center">
          {/* Subtle Background Glow & Badge */}
          <div className="relative inline-block mb-6">
            <div className="absolute inset-0 bg-blue-400/20 blur-2xl rounded-full scale-150 pointer-events-none" />
            <span className="relative inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-xs font-semibold bg-[#EBF3FB] text-[#115B9D] border border-[#115B9D]/20 shadow-sm">
              <span className="size-2 rounded-full bg-[#115B9D] animate-pulse" />
              Error 404 · Page Not Found
            </span>
          </div>

          {/* Large Stylized 404 Display */}
          <div className="relative mb-6 select-none">
            <h1 className="text-8xl sm:text-9xl font-black tracking-tight text-transparent bg-clip-text bg-gradient-to-br from-[#115B9D] via-[#116DAE] to-[#0D4B82] drop-shadow-sm">
              404
            </h1>
          </div>

          {/* Message */}
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">
            Looks like you've taken a wrong turn
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-lg mx-auto mb-8 leading-relaxed">
            The page you are looking for doesn't exist, has been removed, or is temporarily unavailable. Let's get you back on track!
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto mb-10">
            <Link
              to="/"
              className="w-full sm:w-auto flex-1 flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-gradient-to-br from-[#115B9D] to-[#116DAE] text-white font-semibold text-sm shadow-md hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] transition-all duration-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              Back to Home
            </Link>

            <Link
              to="/products"
              className="w-full sm:w-auto flex-1 flex items-center justify-center gap-2 px-6 py-3.5 rounded-xl bg-white border border-gray-200 text-gray-700 font-semibold text-sm hover:bg-gray-50 hover:border-gray-300 hover:text-[#115B9D] shadow-sm transition-all duration-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="8" cy="21" r="1" />
                <circle cx="19" cy="21" r="1" />
                <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
              </svg>
              Browse Catalog
            </Link>
          </div>

          {/* Helpful Support Footer Card */}
          <div className="p-4 sm:p-5 rounded-2xl bg-white border border-gray-100 shadow-sm inline-flex flex-col sm:flex-row items-center gap-3 text-xs sm:text-sm text-gray-500">
            <span>Can't find the beverage equipment or part you need?</span>
            <Link
              to="/contact/us"
              className="font-semibold text-[#115B9D] hover:underline inline-flex items-center gap-1"
            >
              Contact Support
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NoPages;
